import PropTypes from 'prop-types';

import { createTypes } from 'app/shared/utils/createTypes';

export const ActionTypes = createTypes(['CONTENTFUL_ENTRY_']);

export const FileShape = PropTypes.shape({
  fields: PropTypes.shape({
    path: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }),
});
